import { render, staticRenderFns } from "./VuesticProfileCard.vue?vue&type=template&id=03b77fb6"
import script from "./VuesticProfileCard.vue?vue&type=script&lang=js"
export * from "./VuesticProfileCard.vue?vue&type=script&lang=js"
import style0 from "./VuesticProfileCard.vue?vue&type=style&index=0&id=03b77fb6&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03b77fb6')) {
      api.createRecord('03b77fb6', component.options)
    } else {
      api.reload('03b77fb6', component.options)
    }
    module.hot.accept("./VuesticProfileCard.vue?vue&type=template&id=03b77fb6", function () {
      api.rerender('03b77fb6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/vuestic-theme/vuestic-components/vuestic-profile-card/VuesticProfileCard.vue"
export default component.exports